"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.sort");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _ossUpload = require("@/utils/ossUpload");
var _personalCenter = require("@/api/operationManagement/personalCenter");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    draggable: _vuedraggable.default
  },
  data: function data() {
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请上传图片'));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        //   this.$refs.ruleForm.validateField('checkPass')
        // }
        callback();
      }
    };
    return {
      typeList: [],
      typeBoole: false,
      drawer: false,
      title: '',
      key: '',
      rules: {
        name: [{
          required: true,
          message: '请填写名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        pictureUrl: [{
          required: true,
          validator: validatePass,
          trigger: 'change'
        }]
      },
      formData: {
        name: '',
        type: '',
        key: '',
        url: '',
        pictureUrl: '',
        radio: 1,
        pictureUrl1: '',
        mark: 0,
        infoMsg: ''
      },
      pictureUrl: '',
      pictureUrl1: '',
      dialogVisible: false,
      tableData: [],
      options: [],
      type: '',
      val: '',
      page: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      id: '',
      moreList: [],
      dgLoading: false
    };
  },
  watch: {
    drawer: function drawer(val) {
      if (!val) {
        this.moreList = [];
        this.getTableList();
      }
    }
  },
  mounted: function mounted() {
    this.findTypes();
    this.getTableList();
  },
  methods: {
    typeUpdate: function typeUpdate(val) {
      val.read = false;
    },
    saveType: function saveType(val, index) {
      var _this = this;
      var obj = {
        appId: val.appId,
        configGroupCode: val.id ? val.configGroupCode : new Date().getTime(),
        configGroupName: val.configGroupName,
        userId: this.$store.getters.userId
      };
      var str = '';
      if (val.id) {
        obj['id'] = val.id;
        str = 1;
      } else {
        str = 2;
        if (!val.configGroupName) {
          this.$message({
            type: 'error',
            message: '请输入内容'
          });
          return;
        }
      }
      var buff = {
        1: _personalCenter.updateGroup,
        2: _personalCenter.saveGroup
      };
      buff[str](obj).then(function (res) {
        if (res.data) {
          _this.$message({
            type: 'success',
            message: '操作成功'
          });
          _this.findTypes();
        }
      });
    },
    typeDel: function typeDel(val, index) {
      var _this2 = this;
      if (val.id) {
        this.$confirm('确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          (0, _personalCenter.delGroup)({
            userId: _this2.$store.getters.userId,
            id: val.id,
            appId: val.appId
          }).then(function (res) {
            if (res.data) {
              _this2.$message({
                type: 'success',
                message: '操作成功'
              });
              _this2.findTypes();
            }
          });
        }).catch(function () {
          _this2.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        this.typeList.splice(index, 1);
      }
    },
    addType: function addType() {
      this.typeList.push({
        configGroupName: '',
        appId: this.$store.getters.appId,
        userId: this.$store.getters.userId,
        read: false
      });
    },
    typeClick: function typeClick() {
      this.typeBoole = true;
      this.findTypes();
    },
    findTypes: function findTypes() {
      var _this3 = this;
      (0, _personalCenter.findConfigGroupList)({
        userId: this.$store.getters.userId,
        appId: this.$store.getters.appId
      }).then(function (res) {
        if (res.data.length > 0) {
          _this3.options = [];
          _this3.typeList = res.data.map(function (i) {
            _this3.options.push({
              value: i.configGroupCode,
              label: i.configGroupName
            });
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, i), {}, {
              'read': true
            });
          });
        } else {
          (0, _personalCenter.saveGroup)({
            appId: _this3.$store.getters.appId,
            configGroupCode: 'centerFourCard',
            configGroupName: '个人中心四连块',
            userId: _this3.$store.getters.userId
          }).then(function () {
            _this3.findTypes();
          });
        }
      });
    },
    add: function add(to) {
      console.log(to);
    },
    onEnd: function onEnd(val, event) {
      var _this4 = this;
      console.log(this.moveBuf());
      if (this.moveBuf().bstop) {
        // 跨类拖拽
        var clone = (0, _objectSpread2.default)({}, this.moveBuf().copyObj);
        console.log('我跨类拖拽了');
        clone['sort'] = event.newIndex + 1;
        clone['configGroupCode'] = this.moveBuf().configGroupCode;
        var obj = {
          pattern: 'move',
          sourceConfigVo: this.moveBuf().obj,
          targetConfigVo: clone
        };
        console.log(obj);
        this.dgLoading = true;
        (0, _personalCenter.dragUpdateConfig)(obj).then(function (res) {
          _this4.moreClick();
        }).catch(function () {
          _this4.dgLoading = false;
        });
      } else {
        // 同类拖拽
        console.log(event.newIndex - event.oldIndex);
        if (event.newIndex - event.oldIndex !== 0) {
          // 不等于0代表拖拽了，否则就是没有拖拽
          var _obj = {};
          if (event.newIndex - event.oldIndex === 1 || event.newIndex - event.oldIndex === -1) {
            // 代表两两交换
            console.log('sourceConfigVo', val[event.newIndex]);
            console.log('targetConfigVo', val[event.newIndex - event.oldIndex === 1 ? event.newIndex - 1 : event.newIndex + 1]);
            val[event.newIndex]['sort'] = event.newIndex + 1;
            val[event.newIndex - event.oldIndex === 1 ? event.newIndex - 1 : event.newIndex + 1]['sort'] = event.newIndex - event.oldIndex === 1 ? event.newIndex : event.newIndex + 2;
            _obj = {
              pattern: 'exchange',
              sourceConfigVo: val[event.newIndex],
              targetConfigVo: val[event.newIndex - event.oldIndex === 1 ? event.newIndex - 1 : event.newIndex + 1]
            };
            console.log(_obj);
          } else {
            // 有跨度的交换
            console.log('我是有跨度的交换');
            var copyObj = (0, _objectSpread2.default)({}, val[event.newIndex]);
            copyObj['sort'] = event.oldIndex + 1;
            val[event.newIndex]['sort'] = event.newIndex + 1;
            _obj = {
              pattern: 'move',
              targetConfigVo: val[event.newIndex],
              sourceConfigVo: copyObj
            };
            console.log(_obj);
          }
          this.dgLoading = true;
          (0, _personalCenter.dragUpdateConfig)(_obj).then(function (res) {
            _this4.moreClick();
          }).catch(function () {
            _this4.dgLoading = false;
          });
        }
      }
    },
    moveBuf: function moveBuf() {
      var bstop = false;
      var obj = null;
      var configGroupCode = '';
      this.moreList.map(function (i) {
        i.items.map(function (m) {
          if (m.configGroupCode !== i.configGroupCode) {
            obj = m;
            bstop = true;
            configGroupCode = i.configGroupCode;
          }
        });
      });
      return {
        bstop: bstop,
        obj: obj,
        configGroupCode: configGroupCode,
        copyObj: (0, _objectSpread2.default)({}, obj)
      };
    },
    del: function del(val) {
      var _this5 = this;
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _personalCenter.delItem)({
          id: val.id,
          userId: _this5.$store.getters.userId,
          appId: _this5.$store.getters.appId
        }).then(function (res) {
          if (res.code === 0) {
            _this5.$message({
              type: 'success',
              message: '删除成功'
            });
            _this5.getTableList();
          }
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 图片上传逻辑
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              if (val === 'pictureUrl') {
                this.formData.pictureUrl = pictureUrl;
              } else {
                this.formData.pictureUrl1 = pictureUrl;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    search: function search() {
      this.page = 1;
      this.getTableList();
    },
    inSert: function inSert() {
      this.key = 'add';
      this.title = '新增';
      this.dialogVisible = true;
    },
    detail: function detail(val) {
      var _this6 = this;
      this.key = 'upDate';
      this.id = val.id;
      this.title = '编辑';
      this.dialogVisible = true;
      setTimeout(function () {
        _this6.formData.type = val.configGroupCode;
        _this6.formData.name = val.configName;
        _this6.formData.radio = val.enable ? 1 : 0;
        _this6.formData.pictureUrl = val.picUrl;
        _this6.formData.mark = val.tagFlag * 1;
        _this6.formData.pictureUrl1 = val.tagUrl;
        _this6.formData.key = val.configCode;
        _this6.formData.url = val.jumpUrl;
        _this6.formData.infoMsg = val.remark;
      });
    },
    resetForm: function resetForm() {
      this.pictureUrl = '';
      this.pictureUrl1 = '';
      // this.$refs.form1.clearValidate()
      this.$refs.form1.resetFields();
    },
    getOpen: function getOpen() {
      var _this7 = this;
      this.$nextTick(function () {
        _this7.$refs.form1.clearValidate();
      });
    },
    close: function close() {
      var _this8 = this;
      this.$nextTick(function () {
        _this8.$refs.form1.resetFields(); // 只清除清除验证
      });
      this.pictureUrl = '';
      this.pictureUrl1 = '';
      this.dialogVisible = false;
    },
    getTableList: function getTableList() {
      var _this9 = this;
      this.listLoading = true;
      (0, _personalCenter.getList)({
        configGroupCode: this.type,
        configName: this.val,
        page: {
          size: this.limit,
          page: this.page
        },
        userId: this.$store.getters.userId,
        appId: this.$store.getters.appId
      }).then(function (res) {
        _this9.total = res.data.total;
        _this9.tableData = res.data.data;
        _this9.listLoading = false;
      }).catch(function () {
        _this9.listLoading = false;
      });
    },
    // getMoreList(val) {
    //   findConfigAll({
    //     configGroupCode: val
    //   }).then(res => {
    //     console.log(res)
    //   }).catch(() => { })
    // },
    moreClick: function moreClick() {
      var _this0 = this;
      (0, _personalCenter.findConfigAll)({
        userId: this.$store.getters.userId,
        appId: this.$store.getters.appId
      }).then(function (res) {
        _this0.moreList = res.data.sort(function (a, b) {
          return a.configGroupCode - b.configGroupCode;
        });
        // this.moreList = res.data
        _this0.drawer = true;
        _this0.dgLoading = false;
      }).catch(function () {
        _this0.dgLoading = false;
      });
      // this.options.map(i => {
      //   findConfigAll({
      //     configGroupCode: i.value
      //   }).then(res => {
      //     console.log(res.data)
      //     this.moreList.push({ name: i.label, list: res.data })
      //   }).catch(() => { })
      // })
    },
    clearSearch: function clearSearch() {
      this.page = 1;
      this.type = '';
      this.val = '';
      this.getTableList();
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.getTableList();
    },
    // 当前分页
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableList();
    },
    isOk: function isOk() {
      var _this1 = this;
      this.$refs.form1.validate(function (valid) {
        if (valid) {
          var obj = {
            configGroupCode: _this1.formData.type,
            configGroupName: _this1.options.filter(function (i) {
              return i.value === _this1.formData.type;
            })[0].label,
            configName: _this1.formData.name,
            enable: _this1.formData.radio,
            picUrl: _this1.formData.pictureUrl,
            tagFlag: _this1.formData.mark,
            tagUrl: _this1.formData.pictureUrl1,
            configCode: _this1.formData.key,
            jumpUrl: _this1.formData.url,
            userId: _this1.$store.getters.userId,
            appId: _this1.$store.getters.appId,
            remark: _this1.formData.infoMsg
          };
          var methodObj = {
            'add': _personalCenter.addItem,
            'upDate': _personalCenter.updateItem
          };
          if (_this1.key === 'upDate') {
            obj['id'] = _this1.id;
          }
          methodObj[_this1.key](obj).then(function (res) {
            _this1.$message({
              message: '操作成功',
              type: 'success'
            });
            if (_this1.key === 'add') {
              _this1.clearSearch();
            } else {
              _this1.getTableList();
            }
            _this1.close();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};